<template>
  <div :class="containerClass">
    <div class="row no-gutters">
      <div v-for="(user, index) in users" :key="index" class="no-gutters col-12 col-md-6 col-xl-4 user">
        <div v-if="user.is_uploader">
          <uploader-card :user="user" :active-user="activeUser" />
        </div>
        <div v-else>
          <user-card :user="user" :auth-user="activeUser" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserCard from "VuePartials/UserCard";
import UploaderCard from "VuePartials/UploaderCard";
import UserCardMixin from "VueMixins/UserCardMixin";
export default {
  components: {
    UserCard,
    UploaderCard,
  },
  mixins: [UserCardMixin],
  props: {
    activeUser: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    containerClass: {
      default: '',
      type: String,
      required: false,
    },
  },
};
</script>
